import { Button, Card, Col, Form, Row, Statistic } from 'antd';
import { FC } from 'react';
import { ArrowClockwise } from 'react-bootstrap-icons';

import { AppFormProps } from '@/common/interfaces';
import { defineInputStatus } from '@/common/utils';

import {
  PagesCriticalCssGenerationStatus,
  PagesCriticalCssGenerationSummary,
  PagesCriticalCssSettingsFormFields,
  PagesCriticalCssSettingsInputs, PagesCriticalCssStatusTag, PagesCriticalCssStyleFilesSelect
} from '@/modules/Pages';

import { PagesCriticalCssScreenDimensionsList } from './PagesCriticalCssScreenDimensionsList';

interface Props extends AppFormProps<typeof PagesCriticalCssSettingsInputs, PagesCriticalCssSettingsFormFields> {
  siteId: string;
  generationSummary: PagesCriticalCssGenerationSummary | undefined;
  isGenerationSummaryLoading: boolean;
  handleRefreshGenerationSummary: () => void;
}

export const PagesCriticalCssSettingsOverviewView: FC<Props> = ({
  siteId,
  formName,
  form,
  generationSummary,
  isGenerationSummaryLoading,
  handleRefreshGenerationSummary,
  initialValues,
  formErrors,
  isFormLoading,
  validationSchema,
  handleFinish,
  handleFinishFailed,
}) => {
  const values = Form.useWatch([], form);
  const isPristine = JSON.stringify(values) === JSON.stringify(initialValues);

  return (
    <Row gutter={[16, 16]} align="stretch">
      <Col span={24} xl={12}>
        <Form
          form={form}
          name={formName}
          layout="vertical"
          initialValues={initialValues}
          disabled={isFormLoading}
          onFinish={handleFinish}
          onFinishFailed={handleFinishFailed}
        >
          <Card
            title="Налаштування"
            extra={
              <Button
                size="small"
                loading={isFormLoading}
                type="primary"
                htmlType="submit"
                disabled={isFormLoading || isPristine}
              >
                Зберегти
              </Button>
            }
          >
            <Form.Item
              label="Файли стилів"
              name={PagesCriticalCssSettingsInputs.StyleFiles}
              validateStatus={defineInputStatus(isFormLoading, formErrors?.styleFiles)}
              rules={validationSchema.styleFiles}
            >
              <PagesCriticalCssStyleFilesSelect siteId={siteId} disabled={isFormLoading} />
            </Form.Item>

            <PagesCriticalCssScreenDimensionsList disabled={isFormLoading} />
          </Card>
        </Form>
      </Col>

      <Col span={24} xl={12}>
        <Card
          title="Результат"
          style={{ height: '100%' }}
          extra={
            <Button
              type="text"
              size="small"
              icon={<ArrowClockwise />}
              loading={isGenerationSummaryLoading}
              onClick={handleRefreshGenerationSummary}
            />
          }
        >
          <Row gutter={[16, 24]}>
            <Col span={12}>
              <Statistic title="Сторінок" value={generationSummary?.totalPages ?? '—'} />
            </Col>

            {Object.values(PagesCriticalCssGenerationStatus).map((status) => (
              <Col key={status} span={12}>
                <Statistic
                  title={<PagesCriticalCssStatusTag status={status} />}
                  value={generationSummary?.statuses[status] ?? '—'}
                />
              </Col>
            ))}
          </Row>
        </Card>
      </Col>
    </Row>
  );
};
